var map = {
	"./Aquarius.svg": 1394,
	"./Aries.svg": 1395,
	"./Cancer.svg": 1396,
	"./Capricorn.svg": 1397,
	"./Gemini.svg": 1398,
	"./Leo.svg": 1399,
	"./Libra.svg": 1400,
	"./Pisces.svg": 1401,
	"./Sagittarius.svg": 1402,
	"./Scorpio.svg": 1403,
	"./Taurus.svg": 1404,
	"./Virgo.svg": 1405
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image ^\.\/.*\.svg$
// module id = 378
// module chunks = 0